import React from 'react';
import { roles } from '@nxsys/store/constants';

const ReportBuilderList = React.lazy(
  () => import('../../../modules/reportBuilder/listing'),
);
const ReportBuilder = React.lazy(
  () => import('../../../modules/reportBuilder/builder'),
);
const ReportExportDownload = React.lazy(
  () => import('../../../modules/reportBuilder/download'),
);

export const reportBuilderConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/report-builder',
    element: <ReportBuilderList />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/report-builder/new',
    element: <ReportBuilder />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/report-builder/exports/:exportId',
    element: <ReportExportDownload />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/report-builder/:id',
    element: <ReportBuilder />,
  },
];
